
import { defineComponent, onMounted, ref } from 'vue'

import * as PIXI from 'pixi.js'
import { LoaderImage } from '@/plugins/pixiExtends'
import { gsap } from 'gsap'
import { PixiPlugin } from 'gsap/PixiPlugin'
import { getPhoneTopStyle } from '@/composables/fxwallet'

// register the plugin
gsap.registerPlugin(PixiPlugin)

// give the plugin a reference to the PIXI object
PixiPlugin.registerPIXI(PIXI)

export default defineComponent({
  setup () {
    const { phoneStyle } = getPhoneTopStyle()
    const bgRef = ref<HTMLCanvasElement>()

    const canvasWidth = window.innerWidth > 375 ? window.innerWidth : 375
    const canvasHeight = window.innerHeight > 812 ? window.innerHeight : 812

    const app = new PIXI.Application({
      width: canvasWidth,
      height: canvasHeight,
      resolution: window.devicePixelRatio,
      antialias: true,
      // resizeTo: window,
      backgroundAlpha: 0,
      forceCanvas: true
    })

    app.view.style.width = canvasWidth + 'px'
    app.view.style.height = canvasHeight + 'px'
    app.view.style.position = 'absolute'
    app.view.style.top = '50%'
    app.view.style.left = '50%'
    app.view.style.transform = 'translate(-50%, -50%)'

    const loaderImage = new LoaderImage({
      imageArr: [
        {
          name: 'rainbow',
          path: require('@/assets/images/skin/e/rainbow.svg')
        },
        {
          name: 'decorate',
          path: require('@/assets/images/skin/e/decorate.svg')
        },
        {
          name: 'boxAfter',
          path: require('@/assets/images/skin/e/box-after.svg')
        },
        {
          name: 'boxBefore',
          path: require('@/assets/images/skin/e/box-before.svg')
        },
        {
          name: 'boxShadow',
          path: require('@/assets/images/skin/e/box-shadow.svg')
        },
        {
          name: 'boxCover',
          path: require('@/assets/images/skin/e/box-cover.svg')
        },
        {
          name: 'coin',
          path: require('@/assets/images/skin/e/coin.svg')
        }
      ],
      resolution: window.devicePixelRatio
    })

    loaderImage.load(draw)

    function draw () {
      // 彩虹
      const rainbowSprite = new PIXI.Sprite(loaderImage.resources.rainbow.texture)

      rainbowSprite.x = canvasWidth - rainbowSprite.width + 102
      rainbowSprite.y = canvasHeight - rainbowSprite.height + 124

      app.stage.addChild(rainbowSprite)

      const centerContainer = new PIXI.Container()

      // 装饰
      const decorateSprite = new PIXI.Sprite(loaderImage.resources.decorate.texture)

      decorateSprite.x = 20

      centerContainer.addChild(decorateSprite)

      const boxContainer = new PIXI.Container()

      const boxContainerGui = {
        coinSprite: {
          coinSpriteX: 0,
          coinSpriteY: 0
        },
        boxBeforeSprite: {
          boxBeforeSpriteX: -12,
          boxBeforeSpriteY: 158
        },
        boxCoverSprite: {
          boxCoverSpriteScale: 0.9,
          boxCoverSpriteX: 0,
          boxCoverSpriteY: 0
        },
        boxShadowSprite: {
          boxShadowSpriteX: -197,
          boxShadowSpriteY: 112
        }
      }

      const boxAfterSprite = new PIXI.Sprite(loaderImage.resources.boxAfter.texture)

      const coinSprite = new PIXI.Sprite(loaderImage.resources.coin.texture)

      boxContainerGui.coinSprite.coinSpriteX = boxAfterSprite.width / 2
      boxContainerGui.coinSprite.coinSpriteY = boxAfterSprite.height / 2 + 20

      coinSprite.anchor.set(0.5, 0.5)

      coinSprite.x = boxContainerGui.coinSprite.coinSpriteX
      coinSprite.y = boxContainerGui.coinSprite.coinSpriteY
      // coinSprite.alpha

      const boxBeforeSprite = new PIXI.Sprite(loaderImage.resources.boxBefore.texture)

      const boxCoverSprite = new PIXI.Sprite(loaderImage.resources.boxCover.texture)
      boxCoverSprite.anchor.x = 0.5
      boxCoverSprite.anchor.y = 0.5

      boxContainerGui.boxCoverSprite.boxCoverSpriteX = boxAfterSprite.width / 2
      boxContainerGui.boxCoverSprite.boxCoverSpriteY = boxAfterSprite.height / 2 - 33

      boxCoverSprite.x = boxContainerGui.boxCoverSprite.boxCoverSpriteX
      boxCoverSprite.y = boxContainerGui.boxCoverSprite.boxCoverSpriteY

      app.ticker.add(() => {
        boxBeforeSprite.x = boxContainerGui.boxBeforeSprite.boxBeforeSpriteX
        boxBeforeSprite.y = boxContainerGui.boxBeforeSprite.boxBeforeSpriteY
      })

      gsap.fromTo(coinSprite, { pixi: { alpha: 0 } }, { pixi: { alpha: 1 }, duration: 0.5, delay: 0.5 }).then(() => {
        gsap.to(coinSprite, { pixi: { y: coinSprite.y + 20 }, duration: 3, repeat: -1, yoyo: true, ease: 'ease' })
        gsap.to(coinSprite, { pixi: { rotation: 6 }, duration: 2, delay: 4, repeatDelay: 4, repeat: -1, yoyo: true, ease: 'linear' })
      })
      gsap.to(boxCoverSprite, { y: boxCoverSprite.y - 66, duration: 1.2, delay: 0.5 })

      boxContainer.y = 196
      boxContainer.addChild(boxAfterSprite, coinSprite, boxBeforeSprite, boxCoverSprite)

      // 影子
      const boxShadowSprite = new PIXI.Sprite(loaderImage.resources.boxShadow.texture)

      app.ticker.add(() => {
        boxShadowSprite.x = boxContainerGui.boxShadowSprite.boxShadowSpriteX
        boxShadowSprite.y = boxContainerGui.boxShadowSprite.boxShadowSpriteY
      })

      centerContainer.addChild(boxShadowSprite, boxContainer)

      centerContainer.x = canvasWidth / 2 - boxContainer.width / 2 + 12
      centerContainer.y = canvasHeight / 2 - centerContainer.height / 2

      app.stage.addChild(centerContainer)
    }

    onMounted(() => {
      if (bgRef.value) {
        bgRef.value.appendChild(app.view)
      }
    })

    return {
      bgRef,
      phoneStyle
    }
  }
})
